import MediaHelper from "../../../helpers/MediaHelper";
import NewsFormError from "../errors/NewsFormError";
import Module from "../../../models/module/Module";
import StandardTextFormEditorComponent from "../../basics/form/StandardTextFormEditorComponent";
import MediaImageUploadComponent from "../../media/image/MediaImageUploadComponent";
import moment from "moment";

class NewsTextFormComponent {
    static fields(settings) {
        return [
            {
                type: "row",
                children: [
                    {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.News.Content.Form.title",
                                type: "text",
                                name: 'title',
                                customFeedback: NewsFormError,
                                formErrorName: "title"
                            }
                        ]
                    },
                    settings.use_categories ?
                        {
                            type: "col",
                            md: 6,
                            fields: [
                                {
                                    title: 'CMS.News.Content.Form.category',
                                    type: "select",
                                    name: "category",
                                    options: settings.references.map(item => {
                                        if (item.children.length) return false;
                                        return { value: item.id, label: item.depthLabel.join(' > ') };
                                    }).filter(x => x !== false),
                                    customFeedback: NewsFormError,
                                    formErrorName: "category"
                                }
                            ]
                        }
                        : {},
                    { type: "col", md: 12, fields: [] },
                    settings.show_date ? {
                        type: "col",
                        md: 6,
                        fields: [
                            {
                                title: "CMS.News.Content.Form.published_at",
                                type: "datetime",
                                name: 'published_at',
                                // optional: true,
                                customProps: { min: moment().format('YYYY-MM-DD') },
                                customFeedback: NewsFormError,
                                formErrorName: "published_at"
                            }
                        ]
                    } : {},
                    { type: "col", md: 12, fields: [] },
                    settings.show_date ? {
                        type: "col",
                        md: 6,
                        fields: [
                            {
                                title: "CMS.News.Content.Form.expired_at",
                                type: "datetime",
                                name: 'expired_at',
                                optional: true,
                                customProps: { min: moment().format('YYYY-MM-DD') },
                                customFeedback: NewsFormError,
                                formErrorName: "expired_at"
                            }
                        ]
                    } : {},
                    settings.show_summary ? {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.News.Content.Form.summary",
                                type: "textarea",
                                name: 'summary',
                                customFeedback: NewsFormError,
                                formErrorName: "summary"
                            }
                        ]
                    } : {},
                    {
                        type: "col",
                        md: 12,
                        fields: [],
                        custom: StandardTextFormEditorComponent,
                        customProps: { valueField: 'content', label: 'CMS.News.Content.Form.content', placeholder: 'CMS.News.Content.Form.content.placeholder' }
                    },
                    {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.News.Content.Form.seo_title",
                                type: "text",
                                name: 'seo_title',
                                optional: true,
                                customFeedback: NewsFormError,
                                formErrorName: "seo_title"
                            }
                        ]
                    },
                    {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.News.Content.Form.seo_tags",
                                type: "tags",
                                name: 'seo_tags',
                                optional: true,
                                customFeedback: NewsFormError,
                                formErrorName: "seo_tags"
                            }
                        ]
                    },
                    {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.News.Content.Form.seo_description",
                                type: "textarea",
                                name: 'seo_description',
                                optional: true,
                                customFeedback: NewsFormError,
                                formErrorName: "seo_description"
                            }
                        ]
                    },
                    settings.show_cover_image ? {
                        type: "col",
                        md: 12,
                        fields: [],
                        optional: true,
                        custom: MediaImageUploadComponent,
                        customProps: { label: 'CMS.News.Content.Form.image', type: 'news_image', settings: settings, field: 'image', formErrorName: 'image' }
                    } : {},
                    settings.need_header_img ? {
                        type: "col",
                        md: 12,
                        fields: [],
                        optional: true,
                        custom: MediaImageUploadComponent,
                        customProps: { label: 'CMS.News.Content.Form.header_image', type: 'news_header_image', dimensionPrefix: 'header_img', settings: settings, field: 'header_image', formErrorName: 'header_image' }
                    } : {}
                ]
            }
        ]
    }

    static async fields_image_before_submit(element) {
        return new Promise(async (resolve, reject) => {
            let module = Module.get();
            let item = element.state.model;

            let type = module ? module.module.type : null;
            // let id = module ? module.id : null;

            if (item.image !== null && item.image !== undefined && (typeof item.image !== 'string')) {
                item.image = await MediaHelper.uploadImage(item, 'image', 'news_image', type, element.props.id, null, item.title);
            }

            if (item.header_image !== null && item.header_image !== undefined && (typeof item.header_image !== 'string')) {
                item.header_image = await MediaHelper.uploadImage(item, 'header_image', 'news_header_image', type, element.props.id, null, item.title);
            }

            element.setState({ model: item }, () => resolve(true))
        })
    }

    static renderOptionLabel = (reference, item, language) => {
        switch (reference.type) {
            case 'category':
                return item.depthLabel.join(' > ');
            default:
                let content = item[reference.type].contents.filter(content => content.language === language)[0];
                if (!content) content = item[reference.type].contents[0];
                return content.title ? content.title : (content.name ? content.name : '');
        }
    }
}

export default NewsTextFormComponent;